import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Dropdown from 'flarum/common/components/Dropdown';
import Icon from 'flarum/common/components/Icon';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import { localToday, lookFor, ownFlame, t, tierFor, tierName } from '../../common/streak/flame';
import { celebrate } from './celebrate';
/** The menu's contents, fetched as their own chunk the first time it opens. */
let Menu = null;

/**
 * The flame in the header, beside notifications: the count at a glance, and
 * one tap for the streak, the next tier and the month.
 *
 * 🚨 `lazyDraw`: the menu — and the month it fetches — exists only once it is
 * opened. Closed, this is an icon and a number read off the session user.
 */
export default class FlameButton extends Component {
  view() {
    const flame = ownFlame();
    const days = flame?.current || 0;
    const look = lookFor(days, app.session.user);
    const atRisk = days > 0 && flame?.lastDay !== localToday();
    const label = days ? t('badge_label', {
      count: days,
      tier: tierName(tierFor(days))
    }) : t('no_flame');
    return m(Dropdown, {
      className: 'FlameDropdown' + (days ? '' : ' is-out') + (atRisk ? ' is-at-risk' : ''),
      buttonClassName: "Button Button--flat FlameDropdown-button",
      menuClassName: "Dropdown-menu--right FlameDropdown-menu",
      accessibleToggleLabel: label,
      lazyDraw: true,
      onshow: () => {
        if (!Menu) {
          import(/* webpackChunkName: 'forum/streak/FlameMenu', webpackMode: 'lazy-once' */ './FlameMenu').then(mod => {
            Menu = mod.default;
            m.redraw();
          });
        }
      },
      label: m("span", {
        className: "FlameDropdown-label",
        style: {
          '--flame': look.color
        },
        title: label
      }, m(Icon, {
        name: look.icon
      }), m("span", {
        className: "FlameDropdown-count"
      }, days))
    }, m("li", {
      className: "FlameDropdown-panel"
    }, Menu ? m(Menu, {
      days: days,
      color: look.color
    }) : m(LoadingIndicator, {
      size: "small"
    })));
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    celebrate();
  }

  // A post that reaches a milestone brings the fresh flame back in its
  // response; the header is the one thing on every page to notice.
  onupdate() {
    celebrate();
  }
}
flarum.reg.add('ernestdefoe-cadence', 'forum/streak/FlameButton', FlameButton);flarum.reg.addChunkModule('ernestdefoe-cadence:forum/streak/FlameMenu', '974', 'ernestdefoe-cadence', 'forum/streak/FlameMenu');